<template>
  <div class="swimming_print">
    <div id="printswim">
      <h1>{{details.matchName}}比赛</h1>
    <p class="register_table_title">{{$attrs.name}}报名表</p>
      <table id="tables" style="table-layout:fixed;word-break: break-all; word-wrap: break-word;width:100%;border:1px solid #999" border="0" bordercolor="#444" cellspacing="0" cellpadding="0">
        <thead>
          <th
            v-for="(item,index) in columns"
            :key="index"
            :style="{borderRight:index + 1 !== columns.length?'1px solid #999':'',width:item.width + 'px'}"
            style="font-size:14px;padding:8px 0;word-break:break-all; word-wrap:break-word;position:relative;"
          >{{item.title}}</th>
        </thead>
        <tbody>
          <tr v-for="(item,index) in tableData" :key=" index">
            <template v-for="(temp,num) in columns">
              <td 
              style="word-break:break-all;"
              :style="{borderRight:num + 1 !== columns.length?'1px solid #999':'',borderTop:index !== tableData.length?'1px solid #999':''}"              
              :key="num + '_' + index">{{getKey(temp.key,index)}}</td>
            </template>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { getSession } from "@/utils/storage";
import { signDetail, signList } from "@/api/sign-up-match";
import { method } from "@/utils/utils";
import athletesPhoto from "./athletes-photo";
import { getMatchList } from "@/api/sports-management";
import html2Canvas from "html2canvas";
import JsPDF from "jspdf";
export default {
  props: {
    info: {
      type: Object
    }
  },
  data() {
    return {
      isPrintOrPdf: "",
      isShowBottom: false,
      loading: null,
      showTableNum: 0,
      isShowBorder: true,
      isRender: false,
      matchList: [],
      switchType: 1,
      matchName: "",
      schoolList: [],
      details: {},
      tableData: {},
      userInfo: JSON.parse(getSession("userInfo")) || "",
      query: {
        year: new Date().getFullYear(),
        id: "",
        matchId: ""
      },
      columns: [
        {
          title: "单位",
          key: "schoolName"
        },
        {
          title: "身份",
          width: 60,
          key: "identity"
        },
        {
          title: "兼任",
          width: 50,
          key: "partTime"
        },
        {
          title: "性别",
          width: 40,
          key: "gender"
        },
        {
          title: "组别",
          width: 40,
          key: "group"
        },
        {
          title: "姓名",
          key: "name"
        },
        {
          title: "姓名全拼",
          key: "pinyin"
        },
        {
          title: "身份证号",
          key: "idCard"
        },
        {
          title: "出生日期",
          key: "birthday"
        },
        {
          title: "注册号码",
          key: "registerNumber"
        },
        {
          title: "比赛号",
          width: 70,
          key: "matchNumber"
        },
        {
          title: "分计单位",
          width: 60,
          key: "subUnit"
        },
        {
          title: "教练",
          width:60,
          key: "coachName"
        },
        {
          title: "备注",
          width: 50,
          key: "remarks"
        },
        {
          title: "距离",
          width: 50,
          key: "distance"
        },
        {
          title: "泳式",
          width: 50,
          key: "swimmingStyle"
        },
        {
          title: "报名成绩",
          width: 60,
          key: "score"
        },
        {
          title: "测验",
          width: 40,
          key: "test"
        },
        {
          title: "特殊标记",
          width: 60,
          key: "mark"
        }
      ]
    };
  },
  computed: {
    // 网球、羽毛球、乒乓球公用
    isOtherBall() {
      return (
        this.userInfo.project === 1 ||
        this.userInfo.project === 5 ||
        this.userInfo.project === 6
      );
    },
    // 获取学校名称
    getSchoolName() {
      let str = "";
      this.schoolList.filter(item => {
        if (item.id === this.query.id) str = item.schoolName;
      });
      return str;
    },
    // 获取赛事名称
    getMatchName() {
      let str = "";
      this.matchList.filter(item => {
        if (item.id === this.query.matchId) {
          str = item.name;
          this.matchName = item.name;
        }
      });
      return str;
    },
    getKey() {
      return (key, index) => {
        let keys = "";
        this.columns.filter(item => {
          if (item.key === key && item.key !== "identity") {
            keys = this.tableData[index][item.key];
          } else if (item.key === key && item.key === "identity") {
            switch (this.tableData[index][item.key]) {
              case 1: {
                keys = "运动员";
                break;
              }
              case 2: {
                keys = "教练";
                break;
              }
              case 3: {
                keys = "领队";
                break;
              }
              case 4: {
                keys = "工作人员";
                break;
              }
              case 5: {
                keys = "医生";
                break;
              }
              default: {
                keys = "代表队";
                break;
              }
            }
          }
        });

        return keys;
      };
    },
    // 表格显示数量
    getTableList() {
      if (this.userInfo.project === 7) {
        return;
      }
      /**
       * 每个表格显示5项数据，如果数据小于5条，则使用空对象填充
       */
      let num = 0;

      if (this.details.athleteList && this.details.athleteList.length < 5) {
        let length = 5 - this.details.athleteList.length;
        for (let i = 0; i < length; i++) {
          this.details.athleteList.push({});
        }

        num = 1;
      } else if (
        /**
         * 数据大于5或等于5条时，则计算表格展示数量，并判断最后一个表格数据<5条时 使用空数据填充
         */
        this.details.athleteList &&
        this.details.athleteList.length >= 5
      ) {
        let length = this.details.athleteList.length;
        if (length / 5 > parseInt(length / 5)) {
          num = parseInt(length / 5) + 1;
        } else {
          num = length / 5;
        }
        if (this.details.athleteList.slice((num - 1) * 5, num * 5).length < 5) {
          let length =
            5 - this.details.athleteList.slice((num - 1) * 5, num * 5).length;
          for (let i = 0; i < length; i++) {
            this.details.athleteList.push({});
          }
        }
      }
      this.showTableNum = num;
      return num;
    },
    formatTime() {
      return data => {
        return method.timeFormat(data);
      };
    }
  },
  watch: {
    info: {
      handler(value) {
        if (value) {
          this.switchType = 1;
          Object.assign(this.query, {
            year: value.year,
            matchId: value.matchId,
            id: value.id
          });
          this.getMatch();
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    // 导出pdf纵向
    exportPdf() {
      var that = this;
      document.documentElement.scrollLeft = 0;
      this.loading = this.$loading({
        lock: false,
        text: "PDF生成中...",
        spinner: "el-icon-loading"
      });
      that.isShowBottom = false;
      that.isShowBorder = false;
      let pageH =
        (document.querySelector("#prints").clientWidth / 595.28) * 841.89;
      let unit = document.querySelectorAll(".unit");
      let unitHeight = 0;
      unit.forEach((item, index) => {
        if ((index + 1) % 4 == 0) {
          item.style.marginTop = "220px";
        }
      });
      let athletePhoto = document.querySelectorAll(".photos");
      athletePhoto.forEach(item => {
        item.style.width = "100px";
        item.style.height = "120px";
      });
      let photos = document.querySelector(".athletes_photo");
      photos.style.border = "none";
      photos.style.padding = "0 20px";
      let rows = document.querySelectorAll(".rows");
      let rowsHeight =
        (document.querySelector(".headers").clientHeight * 841.89) / pageH;
      let rowsFlag = false;
      if (this.userInfo.project !== 7) {
        unit.forEach((item, index) => {
          if (index > 2) {
            var computedStyle;
            if (window.getComputedStyle) {
              computedStyle = getComputedStyle(item, null);
            } else {
              computedStyle = item.currentStyle; //兼容IE的写法
            }
            unitHeight +=
              (item.clientHeight * 841.89) / pageH +
              (computedStyle.marginBottom.split("px")[0] - 0);
          }
        });
        if (unit.length <= 3) {
          switch (unit.length) {
            case 1:
              photos.style.marginTop = 290 * 3 + "px";
              break;
            case 2:
              photos.style.marginTop = 260 * 2 + "px";
              break;
            default:
              photos.style.marginTop = 170 * 1 + "px";
              break;
          }
        } else {
          switch (unit.length % 3) {
            case 1:
              photos.style.marginTop =
                841 - unitHeight + (220 * 841.89) / pageH + 330 + "px";
              break;
            case 2:
              photos.style.marginTop = 360 * 2 + "px";
              break;
            default:
              photos.style.marginTop =
                841 - unitHeight + (220 * 841.89) / pageH + 50 + "px";
              break;
          }
        }
        rows.forEach((item, index) => {
          rowsHeight += (item.clientHeight * 841.89) / pageH;
          if (rowsHeight > 841.89 && index <= 4) {
            item.style.marginTop =
              ((item.clientHeight * 841.89) / pageH) * 2 + "px";
            item.style.borderTop = "1px solid #999";
            rowsFlag = true;
          } else if (rowsHeight > 841.89 && index > 4 && !rowsFlag) {
            item.style.marginTop = "100px";
            item.style.borderTop = "1px solid #999";
          }
        });
      } else {
        photos.style.marginTop = "260px";
      }
      let leftBorder = document.querySelectorAll(".left_border");
      leftBorder.forEach((item, index) => {
        item.style.borderLeft = "1px solid #999";
      });
      let exportPdfRight = document.querySelectorAll(".export_pdf_right");
      exportPdfRight.forEach((item, index) => {
        item.style.borderRight = "1px solid #999";
      });
      let exportPdfBottom = document.querySelectorAll(".export_pdf_bottom");
      exportPdfBottom.forEach((item, index) => {
        item.style.borderBottom = "1px solid #999";
      });
      this.$nextTick(() => {
        html2Canvas(document.querySelector("#prints"), {
          allowTaint: true,
          dpi: 192,
          useCORS: true
        }).then(canvas => {
          let contentWidth = canvas.width;
          let contentHeight = canvas.height;
          let pageHeight = (contentWidth / 592.28) * 841.89;
          let leftHeight = contentHeight;
          let position = 0;
          let imgWidth = 595.28;
          let imgHeight = (592.28 / contentWidth) * contentHeight;
          let pageData = canvas.toDataURL("image/jpeg", 1.0);
          let PDF = new JsPDF("", "pt", "a4");
          if (leftHeight < pageHeight) {
            PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
          } else {
            while (leftHeight > 0) {
              PDF.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
              leftHeight -= pageHeight;
              position -= 842;
              if (leftHeight > 0) {
                PDF.addPage();
              }
            }
          }
          PDF.save(that.details.matchName + ".pdf");
          that.loading.close();
          photos.style.border = "1px solid #999";
          photos.style.padding = "0";
          photos.style.marginTop = "0";
          athletePhoto.forEach(item => {
            item.style.width = "150px";
            item.style.height = "170px";
          });
          unit.forEach((item, index) => {
            if ((index + 1) % 4 == 0) {
              item.style.marginTop = "20px";
            }
          });
          rows.forEach((item, index) => {
            if ((index + 1) % 5 == 0 && index !== 0) {
              item.style.marginTop = "0";
              item.style.borderTop = "none";
            }
          });
          leftBorder.forEach((item, index) => {
            item.style.borderLeft = "none";
          });
          exportPdfRight.forEach((item, index) => {
            item.style.borderRight = "none";
          });
          exportPdfBottom.forEach((item, index) => {
            item.style.borderBottom = "none";
          });
          that.isShowBorder = true;
          that.isShowBottom = true;
        });
      });
    },
    // 导出pdf横向
    exportPdfRow() {
      var that = this;
      this.isPrintOrPdf = "pdf";
      document.documentElement.scrollLeft = 0;
      that.isShowBottom = false;
      that.isShowBorder = false;
      let photos = document.querySelector(".athletes_photo");
      photos.style.border = "none";
      photos.style.padding = "0 20px";
      this.$nextTick(() => {
        html2Canvas(document.querySelector("#prints"), {
          allowTaint: true,
          dpi: 192,
          useCORS: true
        }).then(canvas => {
          let contentWidth = canvas.width;
          let contentHeight = canvas.height;
          let pageHeight = (contentWidth / 841.89) * 592.28;
          let leftHeight = contentHeight;
          let position = 0;
          let imgWidth = 841.89;
          let imgHeight = (841.89 / contentWidth) * contentHeight;
          let pageData = canvas.toDataURL("image/jpeg", 1.0);
          let PDF = new JsPDF("l", "pt", "a4");
          if (leftHeight < pageHeight) {
            PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
          } else {
            while (leftHeight > 0) {
              PDF.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
              leftHeight -= pageHeight;
              position -= 592.28;
              if (leftHeight > 0) {
                PDF.addPage();
              }
            }
          }
          PDF.save(that.details.matchName + ".pdf");
          // that.loading.close();
          photos.style.border = "1px solid #999";
          photos.style.padding = "0";
          that.isShowBorder = true;
          that.isShowBottom = true;
        });
      });
    },
    //
    getShowTableNum() {
      let num = 0;
      if (this.details.athleteList && this.details.athleteList.length < 5) {
        let length = 5 - this.details.athleteList.length;
        for (let i = 0; i < length; i++) {
          this.details.athleteList.push({});
        }

        num = 1;
      } else if (
        /**
         * 数据大于5或等于5条时，则计算表格展示数量，并判断最后一个表格数据<5条时 使用空数据填充
         */
        this.details.athleteList &&
        this.details.athleteList.length >= 5
      ) {
        let length = this.details.athleteList.length;
        if (length / 5 > parseInt(length / 5)) {
          num = parseInt(length / 5) + 1;
        } else {
          num = length / 5;
        }
        if (this.details.athleteList.slice((num - 1) * 5, num * 5).length < 5) {
          let length =
            5 - this.details.athleteList.slice((num - 1) * 5, num * 5).length;
          for (let i = 0; i < length; i++) {
            this.details.athleteList.push({});
          }
        }
      }
      return num;
    },
    // 打印
    print() {
      this.isPrintOrPdf = "print";
      this.isShowBottom = false;
      var that = this;
      var bodys = document.querySelector('#tables');
      this.$nextTick(() => {
        var el = document.querySelector("#printswim"),
          iframe = document.createElement("IFRAME"),
          doc = null;
        iframe.setAttribute("id", "print-iframe");
        iframe.setAttribute(
          "style",
          "width:100%;font-size:20px;text-align:center"
        );
        document.body.appendChild(iframe);
        doc = iframe.contentWindow.document;
        doc.write(
          // '<html><head><style type="text/css" media="print">ul{list-style:none} @page {size: landscape; margin: 0mm 10mm;}  .photos {width:100px!important;height:120px!important} .foot_table {color:rgb(68, 68, 68)!important;font-weight:normal;font-size:14px} .foot_table thead th,.foot_table tbody td {border-bottom:none!important} .foot_table thead th,.foot_table tbody td {font-weight:normal;color:rgba(68,68,68,1);border: 1px solid #222;border-right:none;padding: 6px 0;min-width: 0;box-sizing: border-box;text-overflow: ellipsis;vertical-align: middle;position: relative;text-align: center;} .print_box_border {border:1px solid #999;border-top:none;border-bottom:none} .margin_top {margin-top:20mm!important} foot_table tbody td  {border-top:none} .top_border {border-top:1px solid #999!important} .left_border {border-left:1px solid #999!important} .bottom_border {border-bottom:1px solid #999!important} .right_border {border-right:1px solid #999!important;} .athletes_photo {margin-top:15mm!important;border:none!important} .headers{margin-top:5mm!important;padding:0 0 24px 0!important} .fonts_color {color:#000} .register_number {font-size:14px} .athlete_info {font-size:14px!important;margin-bottom:6px!important} .info_text {word-break:break-all} .page_break {margin-top:15mm!important} .phones {width:230px!important} .info_row {margin:0 0 10px 0;justify-content:space-between} .foots {margin-top:20px} .info {margin-bottom:20px;width:90%} .unit {margin-top:30px;color:#000} .unit tr td {padding:8px 0!important} main {margin:15mm 0} h1 { margin:5mm 0 20px 0; } span.rights {width:785px}</style></head><body style="zoom: 80%;">' +
          //   el.innerHTML +
          //   "</body></html>"
             '<html><head><style type="text/css" media="print">ul{list-style:none} @page {size: auto; margin: 0mm 5mm;} .print_box_border {border:1px solid #999;border-top:none;border-bottom:none} .margin_top {margin-top:20mm!important} .top_border {border-top:1px solid #999!important} .left_border {border-left:1px solid #999!important} .bottom_border {border-bottom:1px solid #999!important} .right_border {border-right:1px solid #999!important;} .athletes_photos {margin-top:15mm!important;border:none!important} .headers{margin-top:5mm!important;padding-top:0!important;border-bottom:none!important} .fonts_color {color:#000} .athlete_info {font-size:16px!important;margin-bottom:6px!important} .info_text {word-break:break-all} .page_break {margin-top:15mm!important} .phones {width:230px!important} .info_row {margin:0 0 15px 0} .foots {margin-top:20px} .info {margin-bottom:20px} table {margin-top:6px;color:#000} table tr td {padding:8px 0!important;font-size:12px;text-align:center} main {margin:15mm 0} h1 { margin:5mm 0 10px 0;padding-top:10px;font-size:24px;text-align:center } span.rights {width:560px}'+ 
          '.register_table_title {margin:0;padding:0;font-size:18px;color:#000}' + 
          '</style></head><body style="zoom: 80%;">' +
            el.innerHTML +
            "</body></html>"
        );

        doc.close();
        iframe.contentWindow.focus();
        iframe.onload = function() {
          iframe.contentWindow.print();
          document.body.removeChild(iframe);
          setTimeout(() => {
            that.isShowBottom = true;
          }, 1000);
        };
        // iframe.contentWindow.print();
      });
    },
    // 选择年份
    selectYear() {
      this.query.matchId = "";
      this.query.id = "";
      this.matchList = [];
      this.schoolList = [];
      this.details = {};
      this.tableData = {};
      this.getMatch();
    },
    // 获取赛事
    getMatch() {
      getMatchList({
        project: this.userInfo.project,
        year: this.query.year,
        pageNo: 1,
        pageSize: 999
      })
        .then(res => {
          this.matchList = [];
          if (res.list.length > 0) {
            this.matchList = res.list;
          }
          this.getList();
        })
        .catch(err => {});
    },
    // 选择赛事
    selectMatch(value) {
      this.query.id = "";
      this.schoolList = [];
      this.details = {};
      this.tableData = {};
      this.matchList.filter(item => {
        if (item.id === value) {
          this.matchName = item.name;
        }
      });
      this.getList();
    },
    // 列表数据
    getList() {
      signList({
        ...this.query,
        pageNo: 1,
        pageSize: 999
      })
        .then(res => {
          this.schoolList = res.list;
          if (this.query.id) this.getSignDetail(this.query.id);
        })
        .catch(err => {});
    },
    // 获取详情数据
    getSignDetail(id = this.query.id) {
      signDetail({ id })
        .then(res => {
          this.details = res;
          this.tableData = [...JSON.parse(JSON.stringify(res.swimAthleteList))];
          this.isRender = true;
        })
        .catch(err => {});
    },
    // 切换按钮组
    selectType(type) {
      this.switchType = type;
    }
  },
  mounted() {}
};
</script>
<style lang="less" scoped>
</style>